export enum QUIZ_STATES{
  COMING_SOON,
  AVAILABLE,
  PROGRESS,
  PASSED,
  FAILED
}
